<template>
    <v-row no-gutters>
        <v-col
            lg="6"
            offset-lg="3"
            md="12"
        >
            <v-progress-linear
                v-if="loading"
                indeterminate
                color="primary"
            />
            <v-row>
                <v-col cols="12">
                    <v-skeleton-loader
                        v-if="loading"
                        class="mx-auto"
                        type="card"
                    />
                    <RavInformation
                        v-if="!loading"
                        :rav="rav"
                        :errors="errors"
                    />
                </v-col>
            </v-row>
            <UnsavedForm
                :unsaved-form="unsavedForm"
                :errors="errors"
                :on-save="saveFunction"
                :on-cancel="cancelObjectChanges"
            />
        </v-col>
    </v-row>
</template>

<script>
import UnsavedForm from '@/components/common/UnsavedForm';
import RavInformation from '@/components/rav/Form/RavInformation';
import { DefaultSnackbar } from '@/app-events.js';

export default {
    name: 'RavForm',
    components: {
        UnsavedForm,
        RavInformation,
    },
    props: {
        rawData: {
            type: Object,
            default: () => ({}),
        },
        rav: {
            type: Object,
            default: () => ({}),
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
        loading: {
            type: Boolean,
            default: false,
        },
        saveFunction: {
            type: Function,
            default: () => ({}),
        },
        discardFunction: {
            type: Function,
            default: () => ({}),
        },
    },
    data() {
        return {
            unsavedForm: false,
        }
    },
    methods: {
        cancelObjectChanges() {
            this.$eventBus.dispatch(new DefaultSnackbar(this.$t('general.changes_discarded')));
            this.discardFunction();
        },
    },
    watch: {
        rav: {
            handler(_, oldValue) {
                if (JSON.stringify(this.rav) === JSON.stringify(this.rawData)) {
                    this.unsavedForm = false;
                } else {
                    this.unsavedForm = true;
                }
            },
            deep: true
        },
        rawData: {
            handler(_, oldValue) {
                if (JSON.stringify(this.rav) === JSON.stringify(this.rawData)) {
                    this.unsavedForm = false;
                } else {
                    this.unsavedForm = true;
                }
            },
            deep: true
        },
    },
};
</script>
